export { Skeleton } from './skeleton';
export type { SkeletonProps } from './skeleton';
export type { SkeletonStylesParams } from './skeleton.styles';
